<!-- Cabeçalho -->
<div class="panel-heading panel-heading-list padding-bottom-10">

  <!-- Lado esquerdo -->
  <div class="pull-left">
    <span><b>{{summary.descricao}} ({{summary.area_total | number:0}}ha)</b></span><br>
    <span class="visit-amount">Visitas de monitoramento: {{(summary.ocorrencias || 0) | number : 0}}</span><br>
    <span ng-if="summary.visita.data">
      <i class="icon-visit" aria-hidden="true"></i> {{(summary.visita.data | date:'dd/MM')}}
    </span>
    <span class="margin-left" ng-if="summary.visita.data_ultima_pulverizacao">
      <i class="icon-pulverization-fill" aria-hidden="true"></i> {{(summary.visita.data_ultima_pulverizacao | date:'dd/MM')}}
    </span>
  </div>
  <!-- Fim: Lado esquerdo -->

  <!-- Ícones de notificação -->
  <div class="panel-header-icons pull-right">

    <!-- Tarefas atrasadas -->
    <span class="label bg-alerta alert-icon pointer margin-left"
          ng-click="card.activateTasks(summary)"
          ng-show="summary.tarefas_atrasadas">
    <i agro-icon-historico historico="{tipo: 'tarefa'}" uib-tooltip="Tarefas atrasadas"
       tooltip-class="tooltip-lines-width" tooltip-placement="right" tooltip-append-to-body="true"></i>
    </span>
    <!-- Fim: Tarefas atrasadas -->

    <!-- Aplicações atrasadas -->
    <span class="label bg-alerta alert-icon pointer margin-left"
          ng-click="card.activateRecommendations(summary)"
          hint="Aplicações atrasadas"
          ng-show="summary.pulverizacoes_atrasadas">
      <i agro-icon-historico historico="{tipo: 'recomendacao'}" uib-tooltip="Recomendações atrasadas"
         tooltip-class="tooltip-lines-width" tooltip-placement="right" tooltip-append-to-body="true"></i>
    </span>
    <!-- Aplicações atrasadas -->

    <!-- Stand -->
    <span class="label alert-icon pointer margin-left"
          ng-class="card.iconClasses(summary.stand)"
          ng-click="card.activateStand(summary.stand, summary)"
          ng-if="summary.stand">
      <i agro-icon-historico historico="{tipo: summary.stand.tipo}" uib-tooltip="{{summary.stand.hint}}"
         tooltip-class="tooltip-lines-width" tooltip-placement="right"  tooltip-append-to-body="true"></i>
    </span>
    <!-- Fim: Stand -->

    <!-- Stand dropdown -->
    <span class="btn-group label bg-neutro alert-icon pointer margin-left"
          uib-dropdown dropdown-append-to-body="true"
          ng-if="summary.gerais.stand.length > 1"
          ng-class="{'item-active': card.hasItemActive(summary.gerais.stand)}">
      <i agro-icon-historico historico="{tipo: summary.gerais.stand[0].tipo}" uib-dropdown-toggle></i>
      <ul class="dropdown-menu no-margin" uib-dropdown-menu>
        <li ng-repeat="stand in summary.gerais.stand">
          <a class="pointer item-dropdown-geral" ng-click="card.activateStand(stand, summary)">
            <span class="label alert-icon pointer margin-right"
                  ng-class="card.iconClasses(stand)">
              <i agro-icon-historico historico="{tipo: stand.tipo}"></i>
            </span>
            {{stand.hint}}
          </a>
        </li>
      </ul>
    </span>
    <!-- Fim: Stand dropdown -->

    <!-- Ícone produtividade -->
    <span class="label alert-icon pointer margin-left"
          ng-class="card.iconClasses(summary.productivity)"
          ng-if="summary.productivity"
          ng-click="card.activateProductivity(summary.productivity, summary)">
      <i agro-icon-historico historico="{tipo: summary.productivity.tipo}"
         uib-tooltip="{{summary.productivity.hint[0]}}"
         tooltip-append-to-body="true"
         tooltip-class="tooltip-lines-width"
         tooltip-placement="right"></i>
    </span>
      <!-- Fim: Ícone produtividade -->

      <!-- Ícone dropdown produtividade -->
      <span class="btn-group label bg-neutro alert-icon pointer margin-left"
            uib-dropdown dropdown-append-to-body="true"
            ng-if="summary.gerais.produtividade.length > 1"
            ng-class="{'item-active': card.hasItemActive(summary.gerais.produtividade)}">
        <i agro-icon-historico historico="{tipo: summary.gerais.produtividade[0].tipo}" uib-dropdown-toggle></i>
        <ul class="dropdown-menu no-margin" uib-dropdown-menu>
          <li ng-repeat="productivity in summary.gerais.produtividade">
            <a class="pointer item-dropdown-geral" ng-click="card.activateProductivity(productivity, summary)">
              <span class="label alert-icon pointer margin-right"
                    ng-class="card.iconClasses(productivity)">
                <i agro-icon-historico historico="{tipo: productivity.tipo}"></i>
              </span>
              {{productivity.hint}}
            </a>
          </li>
        </ul>
      </span>
      <!-- Fim: Ícone dropdown produtividade -->

  </div>
  <!-- Fim: Ícones de notificação -->

</div>
<!-- Fim: Cabeçalho -->

<!-- Conteúdo/detalhes -->
<div class="panel-body">

  <!-- Cultivares -->
  <span ng-repeat="cultivar in summary.cultivares">
    <div class="rown no-margin padding-top cultivar-container">
      <div class="col-xs-2 cultivar-icon">
        <i class="icon-plant"></i>
      </div>
      <div class="col-xs-10">
        <b>{{cultivar.cultura}}</b>
        <a uib-tooltip="Editar plantio" class="text-muted" ng-click="card.editPlantio(cultivar)"
           ng-if="$root.parametros.permite_plantio_simplificado && $root.parametros.nao_cliente_agrogestao">
          <i class="fa fa-edit"></i>
        </a>
        <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
          <a href="">
            <small class="text-light">
              Timeline <span class="caret"></span>
            </small>
          </a>
          <ul class="dropdown-menu" uib-dropdown-menu role="menu">
            <li role="menuitem">
              <a ng-click="card.openTimelineWindow(summary, cultivar, null)">Geral</a>
            </li>
            <li role="menuitem" ng-repeat="operacao in card.timelineOperations">
              <a ng-click="card.openTimelineWindow(summary, cultivar, operacao)">{{::operacao.descricao}}</a>
            </li>
          </ul>
        </div>

        <h6 class="no-margin no-padding">({{cultivar.descricao}} - {{cultivar.area | number:2}} ha)</h6>
        <p class="no-margin" ng-if="cultivar.estadio.id">
          <i class="icon-stage" aria-hidden="true"></i>
          <strong>{{cultivar.estadio.descricao | capitalize}} ({{cultivar.estadio.abreviatura}})</strong>
        </p>
        <p class="no-margin" ng-if="cultivar.relacao_campo.id">
          <b>Campo de Produção</b>: {{cultivar.relacao_campo.descricao}}
        </p>
        <p class="no-margin" ng-if="cultivar.relacao_campo.id">
          <b>Categoria</b>: {{cultivar.relacao_campo.categoria_semente.descricao}}
        </p>
        <p class="no-margin">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          <b>Plantio</b>: {{cultivar.plantio.inicio | date: 'dd/MM/yy'}} a {{cultivar.plantio.fim | date: 'dd/MM/yy'}}
        </p>
        <ul class="list-unstyled info-list">
          <li ng-if="card.isCana(cultivar.cultura)"><b>Nº Corte</b>: {{cultivar.nr_corte | number:0 }}</li>
          <li ng-if="cultivar.informacoes.data_emergencia"><b>Emergência</b>: {{cultivar.informacoes.data_emergencia | date: 'dd/MM'}}</li>
          <li ng-if="cultivar.informacoes.data_estimada_colheita"><b>Estimativa de colheita</b>: {{cultivar.informacoes.data_estimada_colheita | date: 'dd/MM'}}</li>
        </ul>

        <span ng-if="!card.isCana(cultivar.cultura)">
          <p ng-if="cultivar.stand" class="no-margin"><i class="icon-stand" aria-hidden="true"></i>
            <b>Stand</b>: {{(cultivar.stand.estimada | number:0) + ' pl/ha'}}
          </p>
          <ul ng-if="cultivar.stand" class="list-unstyled info-list">
            <li ng-if="cultivar.stand.ideal"><b>Ideal</b>: {{(cultivar.stand.ideal | number:0) + ' pl/ha'}}</li>
            <li ng-if="cultivar.stand.variacao"><b>Variação</b>: {{(cultivar.stand.variacao | number:2) + ' %'}}</li>
          </ul>
        </span>
        <span ng-if="card.isCana(cultivar.cultura)">
          <p ng-if="cultivar.stand" class="no-margin"><i class="icon-stand" aria-hidden="true"></i>
            <b>Stand</b>:
          </p>
          <ul ng-if="cultivar.stand" class="list-unstyled info-list">
            <li ng-if="cultivar.stand.media_area_total"><b>Área de cana média por ha</b>: {{(cultivar.stand.media_area_total | number:0) }}</li>
          </ul>
        </span>
        </span>

        <p ng-if="cultivar.produtividade" class="no-margin"><i class="icon-production" aria-hidden="true"></i>
          <b>Produtividade:</b> {{(cultivar.produtividade.contada | number:0)}} {{card.produtividadeUnidade(cultivar.cultura)}}/ha
        </p>
        <ul ng-if="cultivar.produtividade" class="list-unstyled info-list">
          <li ng-if="cultivar.produtividade.meta"><b>Meta</b>: {{(cultivar.produtividade.meta | number:0)}} {{card.produtividadeUnidade(cultivar.cultura)}}/ha</li>
          <li ng-if="cultivar.produtividade.variacao"><b>Variação</b>: {{(cultivar.produtividade.variacao | number:2) + ' %'}}</li>
        </ul>
        <br>
        <hr class="no-margin">
      </div>
    </div>
  </span>
  <!-- Fim: Cultivares -->

</div>
<!-- Fim: Conteúdo/detalhes -->
